import { t } from "../../../../../../../utils/i18n";
import React from "react";
interface Props {
  data: any;
  onClickEdit: (e: any, step: string) => void;
}

const MailingDetails: React.FC<Props> = ({ data, onClickEdit }) => (
  <div className="card-inner-container">
    <h6 className="card-sub-title">{t("cards.request_form.shipping_billing_details")}</h6>
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">
        {t("cards.request_form.address")}
      </label>
      <div className="col-12 col-md-9">
        <span>{data.address}</span>
      </div>
    </div>
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">{t("cards.request_form.city")}</label>
      <div className="col-12 col-md-9">
        <span>{data.city}</span>
      </div>
    </div>
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">{t("cards.request_form.state")}</label>
      <div className="col-12 col-md-9">
        <span>{data.state}</span>
      </div>
    </div>
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">
        {t("cards.request_form.country")}
      </label>
      <div className="col-12 col-md-9">
        <span>{data.country}</span>
      </div>
    </div>
    <div className="form-group row">
      <label className="col-12 col-md-3 form-label card-sub-title">
        {t("cards.request_form.postal_code")}
      </label>
      <div className="col-12 col-md-9">
        <span>{data.postalCode}</span>
      </div>
    </div>
    <div className="ml-auto">
      <a
        className="btn btn-purple"
        href="#"
        onClick={(e) => onClickEdit(e, "mailing")}
      >
        {t("cards.request_form.edit")} <i className="fa fa-pen"></i>
      </a>
    </div>
  </div>
);

export default MailingDetails;
